"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTH_INFO_AREA = exports.AUTH_INFO_AREA = "authInfo";
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYWN0aW9ucy9hcmVhQ29uc3RhbnRzLmpzeCJdLCJuYW1lcyI6WyJBVVRIX0lORk9fQVJFQSJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBTyxJQUFNQSwwQ0FBaUIsVUFBdkIiLCJmaWxlIjoiYXJlYUNvbnN0YW50cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBBVVRIX0lORk9fQVJFQSA9IFwiYXV0aEluZm9cIjtcbiJdfQ==